import React from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route } from 'react-router-dom'
import WorkflowsEdit from './WorkflowsEdit'
import WorkflowsLst from './WorkflowsLst'
/**
 * @function WorkflowsMain
 * @description Defines the main routing structure for the Workflows module.
 * Includes routes for editing and viewing individual workflow items (`WorkflowsEdit`),
 * as well as listing all workflows (`WorkflowsLst`). Fallback route handles unmatched paths.
 *
 * @returns {JSX.Element} The routing structure for the Workflows module.
 */
const WorkflowsMain = () => {
	return (
		<Routes>
			<Route path=":itmId/*">
				<Route path="edit" element={<WorkflowsEdit />} />
				<Route
					path="view"
					element={<WorkflowsEdit viewOnly={true} />}
				/>
			</Route>
			<Route index element={<WorkflowsLst />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(WorkflowsMain)
